import React from "react";
import {
  Box,
  Card,
  CardContent,
  Chip,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@material-ui/core";
import {
  CheckCircle,
  DeleteOutline,
  Edit,
  MoreVert,
} from "@material-ui/icons";

import { i18n } from "../../translate/i18n";
import { getCatalogByType } from "../../utils/integrationCatalog";
import { IntegrationVisual } from "../IntegrationChannelGrid";
import { Can } from "../Can";

const IntegrationConnectionCard = ({
  item,
  classes,
  user,
  menuAnchor,
  onMenuOpen,
  onMenuClose,
  onEdit,
  onDelete,
}) => {
  const catalogItem = getCatalogByType(item.integrationType);
  const typeLabel = catalogItem
    ? i18n.t(catalogItem.labelKey)
    : item.integrationType;

  return (
    <Card className={classes.connectionCard} variant="outlined">
      <CardContent className={classes.cardContent}>
        <Box className={classes.cardHeader}>
          <Box display="flex" alignItems="center" style={{ gap: 12, minWidth: 0 }}>
            <Box className={classes.integrationLogo}>
              {catalogItem?.visual ? (
                <IntegrationVisual
                  visual={catalogItem.visual}
                  size={30}
                  variant="compact"
                />
              ) : null}
            </Box>
            <Box minWidth={0}>
              <Typography className={classes.cardTitle} noWrap>
                {item.name}
              </Typography>
              <Typography className={classes.cardId}>
                #{item.id} · {typeLabel}
              </Typography>
            </Box>
          </Box>
          <Can
            role={user.profile}
            perform="connections-page:addConnection"
            yes={() => (
              <IconButton size="small" onClick={(e) => onMenuOpen(e, item)}>
                <MoreVert fontSize="small" />
              </IconButton>
            )}
          />
        </Box>

        <Box display="flex" flexWrap="wrap" style={{ gap: 8 }}>
          <Chip
            size="small"
            label={i18n.t("connections.integrationCard.active")}
            className={classes.statusBadge}
            style={{
              backgroundColor: "rgba(5, 150, 105, 0.12)",
              color: "#059669",
            }}
            icon={
              <Box display="flex" alignItems="center" ml={0.5}>
                <CheckCircle style={{ fontSize: 16, color: "#059669" }} />
              </Box>
            }
          />
          {item.webSearchEnabled && item.integrationType === "openai" && (
            <Chip
              size="small"
              label={i18n.t("connections.integrationCard.webSearch", {
                defaultValue: "Búsqueda web",
              })}
              style={{
                backgroundColor: "rgba(37, 99, 235, 0.12)",
                color: "#2563eb",
              }}
            />
          )}
        </Box>

        <Typography className={classes.identifier}>
          {item.kind === "prompt"
            ? i18n.t("connections.integrationCard.openAiConfigured", {
                defaultValue: "Configuración Open AI independiente",
              })
            : item.integrationType === "tavily"
            ? i18n.t("connections.integrationCard.tavilyConfigured", {
                defaultValue: "Búsqueda web Tavily conectada",
              })
            : item.integrationType === "chat_agent"
            ? i18n.t("connections.integrationCard.chatAgentConfigured", {
                defaultValue: "Agente IA de chats conectado",
              })
            : i18n.t("connections.integrationCard.configured", {
                defaultValue: "Integración configurada y lista para usar",
              })}
        </Typography>

        {item.subtitle && (
          <Typography className={classes.identifier}>{item.subtitle}</Typography>
        )}

        <Box className={classes.cardActions}>
          <Can
            role={user.profile}
            perform="connections-page:addConnection"
            yes={() => (
              <Chip
                size="small"
                clickable
                label={i18n.t("connections.integrationCard.edit")}
                onClick={() => onEdit(item)}
                icon={<Edit style={{ fontSize: 14 }} />}
              />
            )}
          />
        </Box>

        {item.updatedAt && (
          <Box className={classes.cardFooter}>
            <Typography className={classes.footerDate}>
              {i18n.t("connections.card.updated")}: {item.updatedAt}
            </Typography>
          </Box>
        )}
      </CardContent>

      <Menu
        anchorEl={menuAnchor?.el}
        open={Boolean(menuAnchor?.el && menuAnchor?.id === item.menuId)}
        onClose={onMenuClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          onClick={() => {
            onEdit(item);
            onMenuClose();
          }}
        >
          <Edit fontSize="small" style={{ marginRight: 8 }} />
          {i18n.t("connections.card.edit")}
        </MenuItem>
        <MenuItem
          onClick={() => {
            onDelete(item);
            onMenuClose();
          }}
        >
          <DeleteOutline fontSize="small" style={{ marginRight: 8, color: "#DC2626" }} />
          {i18n.t("connections.card.delete")}
        </MenuItem>
      </Menu>
    </Card>
  );
};

export default IntegrationConnectionCard;
